import { Stack, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { TFunction } from "i18next";
import { formatNumber } from "../../../../../../common/utils";
import { SitesEmissionsBySource } from "../../../../../../datasources/api-client/data-contracts";
import { ModeKey, typesDataEmissions } from "../../Overview/data";

export const getRowsSitesSource = (data: SitesEmissionsBySource, t: TFunction) => {
	const metaData = typesDataEmissions(t);

	if (!data) return [];

	return Object.entries(data as Record<string, any>)
		.filter(([key]) => key !== "total")
		.map(([key, value], index) => {
			const meta = metaData[key as ModeKey];

			const co2ePercent = value.co2e ? Number(value.co2e.percentage.toFixed(2)) : 0;
			const co2eVal = value.co2e?.value ?? 0;
			const consumptionVal = value.consumption?.value ?? 0;
			const consumptionMeasure = value.consumption?.measure ?? "";

			return {
				id: index,
				type: meta.label,
				iconType: meta.icon,
				emissions: {
					value: co2eVal,
					percent: co2ePercent,
				},
				consumption: {
					value: consumptionVal,
					measure: consumptionMeasure,
				},
			};
		});
};

export const dataColSitesSource: GridColDef[] = [
	{
		field: "sources",
		headerName: "sources",
		flex: 1,
		sortable: false,
		renderCell: (params) => {
			return (
				<Stack direction="row" spacing={1} alignItems="center" height={"100%"}>
					{params.row.iconType}
					<Typography variant="body1">{params.row.type}</Typography>
				</Stack>
			);
		},
	},
	{
		field: "emissions",
		headerName: "emissions",
		flex: 1,
		sortable: false,
		renderCell: (params) => {
			return params ? (
				<Stack spacing={1} height={"100%"} direction={"row"} justifyContent={"flex-end"} alignItems={"center"}>
					<Typography variant="body1" fontWeight={700}>
						{formatNumber(params.value.value, "decimal", 2, 2)}
					</Typography>
					<Typography variant="caption" color="text.secondary">
						({formatNumber(params.value.percent / 100, "percent", 2, 2)})
					</Typography>
				</Stack>
			) : (
				<>-</>
			);
		},
	},
	{
		field: "consumption",
		headerName: "consumption",
		flex: 1,
		sortable: false,
		renderCell: (params) => {
			return params ? (
				<Stack spacing={1} height={"100%"} direction={"row"} justifyContent={"flex-end"} alignItems={"center"}>
					<Typography variant="body1" fontWeight={700}>
						{formatNumber(params.value.value, "decimal", 2, 2)}
					</Typography>
					<Typography variant="caption" color="text.secondary">
						{params.value.measure}
					</Typography>
				</Stack>
			) : (
				<>-</>
			);
		},
	},
];

export const getColumnsSitesSource = (dataCol: GridColDef[], t: TFunction) =>
	dataCol.map((col, index) => {
		const label = col.headerName ? t(`greenrouter/${col.headerName}`) : "";

		return {
			...col,
			headerName: label,
			renderHeader: () => {
				if (!label) {
					return null;
				}

				return (
					<Stack direction="row" sx={{ fontWeight: "bold" }} spacing={1} alignItems="baseline">
						<Typography variant="subtitle1">{label}</Typography>
						<Typography variant="body2" color="text.secondary">
							{
								// measure for Emissions col
							}
							{index === 1 && "tco2e"}
						</Typography>
					</Stack>
				);
			},
		};
	});
